import { Component, OnInit } from '@angular/core';
import { Router,RouterModule} from '@angular/router';
import * as CryptoJS from 'crypto-js';
import { sha256, sha224 } from 'js-sha256';
import { ServerConstantsService } from '../serverConstants.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  firstName:any;
  constructor(public router:Router) { }

  ngOnInit() {
    let key = sha256(ServerConstantsService.serverConstants.privateKey).toString();
    this.firstName = CryptoJS.AES.decrypt(sessionStorage.getItem('firstName'), key).toString(CryptoJS.enc.Utf8);
  }
  logout(){
    
    let key = sha256(ServerConstantsService.serverConstants.privateKey).toString();
    CryptoJS.AES.decrypt(sessionStorage.getItem('conversion_stat'), key).toString(CryptoJS.enc.Utf8) === 'true' ?  
    window.location.replace(ServerConstantsService.serverConstants.ariesUrl) :
    this.router.navigate(['login']);
    sessionStorage.clear();
  }
  toggle(){
    document.querySelector('#collapsibleNavbar2').classList.toggle('toggle');
    document.querySelector('#bars').classList.toggle('change');
  }

}



// WEBPACK FOOTER //
// ./src/app/header/header.component.ts